import WebEngagePlugin from 'react-native-webengage';
import WebengageAnalytics from '../../analytics/WebengageAnalytics';

export default class WebEngageHandler {
  static initialize = (handleUrl) => {
    WebengageAnalytics.optIn();
  };
}
